export const SupportedFirewallAPIs = [
  { value: "s3.GetBucketLocation", label: "s3.GetBucketLocation" },
  { value: "s3.GetBucketPolicy", label: "s3.GetBucketPolicy" },
  { value: "s3.GetBucketEncryption", label: "s3.GetBucketEncryption" },
  {
    value: "s3.GetBucketLifecycleConfiguration",
    label: "s3.GetBucketLifecycleConfiguration",
  },
  {
    value: "s3.GetObjectLockConfiguration",
    label: "s3.GetObjectLockConfiguration",
  },
  {
    value: "s3.GetBucketReplicationConfiguration",
    label: "s3.GetBucketReplicationConfiguration",
  },
  { value: "s3.GetBucketVersioning", label: "s3.GetBucketVersioning" },
  {
    value: "s3.GetBucketNotificationConfiguration",
    label: "s3.GetBucketNotificationConfiguration",
  },
  { value: "s3.ListenNotification", label: "s3.ListenNotification" },
  { value: "s3.ReplicationResyncStatus", label: "s3.ReplicationResyncStatus" },
  { value: "s3.GetBucketTagging", label: "s3.GetBucketTagging" },
  { value: "s3.GetBucketACL", label: "s3.GetBucketACL" },
  { value: "s3.GetBucketCORS", label: "s3.GetBucketCORS" },
  { value: "s3.GetBucketWebsite", label: "s3.GetBucketWebsite" },
  { value: "s3.GetBucketAccelerate", label: "s3.GetBucketAccelerate" },
  { value: "s3.GetBucketRequestPayment", label: "s3.GetBucketRequestPayment" },
  { value: "s3.GetBucketLogging", label: "s3.GetBucketLogging" },
  { value: "s3.GetBucketPolicyStatus", label: "s3.GetBucketPolicyStatus" },
  {
    value: "s3.GetBucketReplicationMetrics",
    label: "s3.GetBucketReplicationMetrics",
  },
  { value: "s3.ListMultipartUploads", label: "s3.ListMultipartUploads" },
  { value: "s3.ListObjectsV2", label: "s3.ListObjectsV2" },
  { value: "s3.ListObjectVersions", label: "s3.ListObjectVersions" },
  { value: "s3.PutBucketACL", label: "s3.PutBucketACL" },
  {
    value: "s3.PutBucketLifecycleConfiguration",
    label: "s3.PutBucketLifecycleConfiguration",
  },
  { value: "s3.PutBucketPolicy", label: "s3.PutBucketPolicy" },
  { value: "s3.PutBucketEncryption", label: "s3.PutBucketEncryption" },
  {
    value: "s3.PutObjectLockConfiguration",
    label: "s3.PutObjectLockConfiguration",
  },
  {
    value: "s3.PutBucketReplicationConfiguration",
    label: "s3.PutBucketReplicationConfiguration",
  },
  { value: "s3.PutBucketVersioning", label: "s3.PutBucketVersioning" },
  {
    value: "s3.PutBucketNotificationConfiguration",
    label: "s3.PutBucketNotificationConfiguration",
  },
  { value: "s3.PutBucketTagging", label: "s3.PutBucketTagging" },
  { value: "s3.ReplicationResyncStart", label: "s3.ReplicationResyncStart" },
  { value: "s3.DeleteBucketTagging", label: "s3.DeleteBucketTagging" },
  { value: "s3.DeleteBucketWebsite", label: "s3.DeleteBucketWebsite" },
  { value: "s3.DeleteBucketPolicy", label: "s3.DeleteBucketPolicy" },
  {
    value: "s3.DeleteBucketReplicationConfiguration",
    label: "s3.DeleteBucketReplicationConfiguration",
  },
  {
    value: "s3.DeleteBucketLifecycleConfiguration",
    label: "s3.DeleteBucketLifecycleConfiguration",
  },
  { value: "s3.DeleteBucketEncryption", label: "s3.DeleteBucketEncryption" },
  { value: "s3.ListObjectParts", label: "s3.ListObjectParts" },
  { value: "s3.GetObjectACL", label: "s3.GetObjectACL" },
  { value: "s3.GetObjectAttributes", label: "s3.GetObjectAttributes" },
  { value: "s3.GetObjectTagging", label: "s3.GetObjectTagging" },
  { value: "s3.GetObjectRetention", label: "s3.GetObjectRetention" },
  { value: "s3.GetObjectLegalHold", label: "s3.GetObjectLegalHold" },
  { value: "s3.GetObjectLambda", label: "s3.GetObjectLambda" },
  { value: "s3.PutObjectACL", label: "s3.PutObjectACL" },
  { value: "s3.PutObjectTagging", label: "s3.PutObjectTagging" },
  { value: "s3.PutObjectRetention", label: "s3.PutObjectRetention" },
  { value: "s3.PutObjectLegalHold", label: "s3.PutObjectLegalHold" },
  { value: "s3.HeadBucket", label: "s3.HeadBucket" },
  { value: "s3.HeadObject", label: "s3.HeadObject" },
  { value: "s3.UploadPartCopy", label: "s3.UploadPartCopy" },
  { value: "s3.UploadPart", label: "s3.UploadPart" },
  { value: "s3.PutObject", label: "s3.PutObject" },
  { value: "s3.PutObjectExtract", label: "s3.PutObjectExtract" },
  { value: "s3.PutBucket", label: "s3.PutBucket" },
  { value: "s3.CopyObject", label: "s3.CopyObject" },
  { value: "s3.ListBuckets", label: "s3.ListBuckets" },
  { value: "s3.GetObject", label: "s3.GetObject" },
  { value: "s3.ListobjectsV1", label: "s3.ListobjectsV1" },
  { value: "s3.DeleteBucket", label: "s3.DeleteBucket" },
  { value: "s3.AbortMultipartUpload", label: "s3.AbortMultipartUpload" },
  { value: "s3.CompleteMultipartUpload", label: "s3.CompleteMultipartUpload" },
  { value: "s3.DeleteObjectTagging", label: "s3.DeleteObjectTagging" },
  { value: "s3.DeleteObject", label: "s3.DeleteObject" },
  { value: "s3.DeleteObjects", label: "s3.DeleteObjects" },
  { value: "s3.PostPolicy", label: "s3.PostPolicy" },
  { value: "s3.SelectObjectContent", label: "s3.SelectObjectContent" },
  { value: "s3.NewMultipartUpload", label: "s3.NewMultipartUpload" },
  { value: "s3.RestoreObject", label: "s3.RestoreObject" },
  { value: "sftp.RMDIR", label: "sftp.RMDIR" },
  { value: "sftp.REMOVE", label: "sftp.REMOVE" },
  { value: "sftp.LIST", label: "sftp.LIST" },
  { value: "sftp.MKDIR", label: "sftp.MKDIR" },
  { value: "sftp.STAT", label: "sftp.STAT" },
  { value: "sftp.GET", label: "sftp.GET" },
  { value: "sftp.PUT", label: "sftp.PUT" },
];
